<script>
import axios from "axios";

import Layout from "../../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import {
	getGalleryPage,
	updateGalleryPage,
} from "../../../../api/services/cms.service";
import { getS3SingedUrl } from "../../../../api/services/general.service";
/**
 * Manage General Page
 */
export default {
	page: {
		title: "Galerie verwalten",
		meta: [
			{
				name: "description",
				content: appConfig.description,
			},
		],
	},
	components: {
		Layout,
		PageHeader,
	},
	data() {
		return {
			title: this.$i18n.t("CMS.galleryPage.mangeGalaryPage"),
			items: [
				{
					text: this.$i18n.t("CMS.galleryPage.mangeGalaryPage"),
					active: true,
				},
			],
			allGalleryImages: null,
			addNewImageIsPossible: true,
			activteImageUploading: [],
		};
	},
	async mounted() {
		this.getAllGalleryImages();
	},
	methods: {
		async getAllGalleryImages() {
			let getAllGalleryImagesFromFunction = await getGalleryPage();
			this.allGalleryImages = getAllGalleryImagesFromFunction[0].gallery_images;
			this.id = getAllGalleryImagesFromFunction[0].id;

			for (let i = 0; i < this.allGalleryImages.length; i++) {
				this.activteImageUploading.push(false);
			}
		},
		clickCloseButton() {
			this.$emit("reload");
		},
		reloadPage() {
			window.location.reload();
		},
		async getS3PresignedUrl(file) {
			const fileName = file.name;
			let getUploadedFileURL = await getS3SingedUrl(fileName);

			let getFileUploadResponse = await axios.put(
				getUploadedFileURL.signedUrl,
				file
			);

			let fileBaseUrl =
				"https://s3.eu-central-1.amazonaws.com/ms-sissi.uploads/";

			if (getFileUploadResponse) {
				return fileBaseUrl + fileName;
			}
			return null;
		},
		clickAddNewImageToGallery() {
			this.allGalleryImages.push(null);
			this.addNewImageIsPossible = false;
			this.activteImageUploading.push(false);
		},
		removeGalleryImage(index) {
			this.allGalleryImages.splice(index, 1);
		},
		async clickSaveButton() {
			await updateGalleryPage(this.id, this.allGalleryImages);
			this.reloadPage();
		},

		async updateGalleyImage(index) {
			this.addNewImageIsPossible = false;
			this.activteImageUploading[index] = true;
			const ref = `galleryImage${index}Input`;

			let file = this.$refs[ref][0].files[0];

			let imageS3Url = await this.getS3PresignedUrl(file);

			this.allGalleryImages.splice(index, 1, imageS3Url);

			this.addNewImageIsPossible = true;
			this.activteImageUploading[index] = false;
		},
		async galleryImageSelect(index) {
			this.activteImageUploading.splice(index, 1, true);
			const ref = `galleryImage${index}Input`;

			let file = this.$refs[ref][0].files[0];

			let imageS3Url = await this.getS3PresignedUrl(file);

			this.allGalleryImages.splice(index, 1, imageS3Url);

			this.addNewImageIsPossible = true;
			this.activteImageUploading.splice(index, 1, false);
		},
	},
};
</script>

<template>
	<Layout>
		<PageHeader :title="title" :items="items" />
		<div class="row" v-if="allGalleryImages">
			<div class="col-md-12">
				<div class="card">
					<div class="card-body">
						<div class="card-title">Galerie Bilder</div>
						<!-- Gallery -->
						<div class="row mt-4">
							<div
								class="col-md-4 mb-5"
								v-for="(image, imageIndex) in allGalleryImages"
								:key="imageIndex"
							>
								<div v-if="image">
									<div
										style="width: 300px; height: 200px"
										class="text-center"
										v-if="activteImageUploading[imageIndex]"
									>
										<i class="bx bx-loader-alt bx-spin text-light display-1" />
									</div>
									<img
										v-else
										:src="image"
										class="img-fluid"
										style="height: 200px; width: 300px"
									/>
									<div class="mt-2">
										<span>
											<input
												:id="'galleryImage' + imageIndex"
												:ref="'galleryImage' + imageIndex + 'Input'"
												type="file"
												name="file"
												accept="image/*"
												style="width: 0.1px; opacity: 0; z-index: -1"
												@change="updateGalleyImage(imageIndex)"
											/>
											<label
												:for="'galleryImage' + imageIndex"
												style="cursor: pointer"
											>
												<i class="bx bxs-message-square-edit text-warning"></i>
												Neu hochladen
											</label>
										</span>
										<span class="ml-4">
											<label
												@click="removeGalleryImage(imageIndex)"
												style="cursor: pointer"
											>
												<i class="bx bxs-message-square-x text-danger"></i>
												Entfernen
											</label>
										</span>
									</div>
								</div>
								<div v-else>
									<div
										style="width: 300px; height: 200px"
										class="text-center"
										v-if="activteImageUploading[imageIndex]"
									>
										<i class="bx bx-loader-alt bx-spin text-light display-1" />
									</div>
									<img
										v-else
										src="@/assets/images/Sample Image.jpg"
										class="img-fluid"
										style="height: 200px; width: 300px"
									/>
									<input
										:id="'galleryImage' + imageIndex"
										:ref="'galleryImage' + imageIndex + 'Input'"
										type="file"
										name="file"
										accept="image/*"
										style="width: 0.1px; opacity: 0; z-index: -1"
										@change="galleryImageSelect(imageIndex)"
									/>
									<label
										:for="'galleryImage' + imageIndex"
										style="cursor: pointer"
									>
										<label
											class="mt-2"
											:for="'galleryImage' + imageIndex"
											style="cursor: pointer"
										>
											<i class="bx bxs-message-square-add text-success"></i>
											Neues Bild hochladen
										</label>
									</label>
									<span class="ml-4">
										<label
											@click="removeGalleryImage(imageIndex)"
											style="cursor: pointer"
										>
											<i class="bx bxs-message-square-x text-danger"></i>
											Entfernen
										</label>
									</span>
								</div>
							</div>
							<div class="col-md-4" v-if="addNewImageIsPossible">
								<div class="" style="height: 100%">
									<div
										class="text-center p-3"
										style="
                      border-radius: 4px;
                      border: 2px dashed #a5a5a5;
                      color: #a5a5a5;
                      background: #fff;
                      cursor: pointer;
                      width: 300px;
                    "
										@click="clickAddNewImageToGallery()"
									>
										<span style="font-size: 18px; font-weight: 600"
											>+ Neues Bild hinzufügen</span
										>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
		<div class="mt-3">
			<b-button variant="success" @click="clickSaveButton()">
				<i class="bx bxs-save mr-1"></i>
				{{ $t("general.buttons.save") }}</b-button
			>
		</div>
	</Layout>
</template>

<style scoped>
.text-limted-one-lines {
	overflow: hidden;
	text-overflow: ellipsis;
	display: -webkit-box;
	-webkit-line-clamp: 1; /* number of lines to show */
	-webkit-box-orient: vertical;
}
.text-limted-two-lines {
	overflow: hidden;
	text-overflow: ellipsis;
	display: -webkit-box;
	-webkit-line-clamp: 2; /* number of lines to show */
	-webkit-box-orient: vertical;
}

.extra-image-preview-after-crop {
	display: flex;
	justify-content: center;
	align-items: center;
	background-color: none;
	width: 120px;
	height: 120px;
	padding: 0;
	margin: 0;
}
</style>
